import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Profile from "./pages/Profile";
import AboutPage from "./pages/AboutPage";

import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import ForgotPassword from "./screens/ForgotPassword";
import RouteRegistration from "./screens/RouteRegistration";
import AdminBanners from "./screens/AdminBanners";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/sobre-nos" element={<AboutPage />} />
        <Route path="/cadastro" element={<RouteRegistration />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin/banners" element={<AdminBanners />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
